var React = require('react');

function Ligo (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(45 213.936 338.119)","fillRule":"evenodd","fill":"currentColor"},[React.createElement("circle",{"cx":"176.907","cy":"250","r":"52.966","key":0}),React.createElement("path",{"d":"M269.972 414.195V287.076h84.746l.105 143.468-69.204 69.203-217.98-.705L0 431.402V287.077h84.746v127.119zm0-328.642V212.67h84.746l.105-143.467L285.619 0 67.64.706 0 68.345V212.67h84.746V85.553z","key":1})]));
}

Ligo.defaultProps = {"viewBox":"0 0 500 500"};

module.exports = Ligo;

Ligo.default = Ligo;
